export default __webpack_public_path__ + "static/media/dollar.f5b45fdc.svg";